export default __webpack_public_path__ + "static/media/pin.a82eefe8.svg";